<template>
  <div class="InviteNewFriends">
    <van-nav-bar
      title="好友列表"
      left-text
      right-text="确定"
      fixed
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div v-if="friends.length" style="margin-top:80px;">暂无其它好友哦！</div>
    <div class="group-content" v-else>
      <van-index-bar :index-list="FirstPin">
        <van-index-anchor v-for="(item, index) in friends" :key="index+'b'" :index="index">
          <van-cell-group class="indexc">
            <div class="indexWord" v-if="item.length > 0">
              <span>{{index}}</span>
            </div>
            <div class="addf" v-for="(it, index) in item" :key="index">
              <van-checkbox-group v-model="result">
                <van-checkbox :name="it.u_id">
                  <div class="iat">
                    <van-image
                      :src="attach_url+it.u_headportrait"
                      width="40px"
                      height="40px"
                      style="margin-top:5px"
                      class="err-image-header"
                    />
                    <van-cell
                      :title="it.f_name.f_name?it.f_name.f_name:it.u_nickname?it.u_nickname:it.u_login_id"
                      :id="it.u_id"
                      @click="onFriendInfo(it.u_id)"
                    />
                  </div>
                </van-checkbox>
              </van-checkbox-group>
            </div>
          </van-cell-group>
        </van-index-anchor>
      </van-index-bar>
    </div>
  </div>
</template>
<script>
var pinyin = require("js-pinyin");
pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
import { FirstPin } from "@/utils/common.js";
export default {
  name: "InviteNewFriends",
  data() {
    return {
      FirstPin: FirstPin,
      ug_id: "",
      friends: [],
      friend_id: "",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      result: [],
      checked: false,
      attach_url: this.Conf.serverPre
    };
  },
  methods: {
    loadData() {
      var params = {
        u_id: this.u_id,
        ug_id: this.ug_id,
        token: this.token
      };
      var url =
        this.Conf.serverUrl +
        "Friends/addFriendsToGroup" +
        "?num=" +
        Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          console.log("fffff", response);
          //   this.friends = response.data.friends;
          // })
          // .catch(error => {});
          var friend = response.data.friends;
          console.log("fffff", this.friends);
          var firstName = {};
          this.FirstPin.forEach(item => {
            firstName[item] = [];
            friend.forEach(el => {
              let first = (el.f_name.f_name
                ? el.f_name.f_name
                : el.u_nickname
                ? el.u_nickname
                : el.u_login_id
              ).substring(0, 1);
              //  console.log("hhhh",first)
              if (/[a-z]/.test(first) || /^[\u4e00-\u9fa5]*$/.test(first)) {
                first = pinyin
                  .getCamelChars(
                    el.f_name.f_name
                      ? el.f_name.f_name
                      : el.u_nickname
                      ? el.u_nickname
                      : el.u_login_id
                  )
                  .substring(0, 1)
                  .toUpperCase(); // 英文
              } else {
                first = "#";
              }
              if (first == item) {
                firstName[item].push(el);
              }
            });
          });
          this.friends = firstName;
          // this.newFriends = response.data.newFriendCount;
          // this.groupCount = response.data.groupCount;
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "GroupChatSet",
        query: {
          ug_id: this.ug_id
        }
      });
    },
    // 确定
    onClickRight() {
      var params = {
        ug_id: this.ug_id,
        u_ids: this.result,
        token: this.token,
        u_id: this.u_id
      };
      var url = this.Conf.serverUrl + "Groups/inviteNewFriends";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              this.$toast.success(response.data.msg);
              
              this.loadData();
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {
          // console.log(error);
        });
      this.result = [];
    },
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    // 全选
    toggleAll() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(false);
      } else {
        this.$refs.checkboxGroup.toggleAll(true);
      }
    }
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.friend_id = params.friend_id;
    this.loadData();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Group/InviteNewFriends.vue